function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useState, useEffect } from "react";
import { Container, Row, Col, Table } from "react-bootstrap";
import { Divider, Skeleton, Button, Modal, Space, Spin, Alert, message } from 'antd';
import Common from "../components/includes/Common";
import NewUserForm from "../components/forms/NewUserForm";
import { TrashFill, PencilFill, Plug, PlugFill, EyeSlashFill, EyeFill, ExclamationCircleFill } from 'react-bootstrap-icons';
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
var confirm = Modal.confirm;
var PlatformUsersManagement = function PlatformUsersManagement() {
  var _useState = useState(true),
    _useState2 = _slicedToArray(_useState, 2),
    isDataLoading = _useState2[0],
    setIsDataLoading = _useState2[1];
  var _useState3 = useState([]),
    _useState4 = _slicedToArray(_useState3, 2),
    users = _useState4[0],
    setUsers = _useState4[1];
  var _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    isNewUserCreated = _useState6[0],
    setIsNewUserCreated = _useState6[1];
  var _useState7 = useState(null),
    _useState8 = _slicedToArray(_useState7, 2),
    selectedUser = _useState8[0],
    setSelectedUser = _useState8[1];
  var _useState9 = useState(false),
    _useState10 = _slicedToArray(_useState9, 2),
    isDataUpdated = _useState10[0],
    setIsDataUpdated = _useState10[1];
  var _useState11 = useState(false),
    _useState12 = _slicedToArray(_useState11, 2),
    isProcessing = _useState12[0],
    setIsProcessing = _useState12[1];
  var _useState13 = useState(''),
    _useState14 = _slicedToArray(_useState13, 2),
    operationSuccessMessage = _useState14[0],
    setOperationSuccessMessage = _useState14[1];
  var _useState15 = useState(''),
    _useState16 = _slicedToArray(_useState15, 2),
    operationErroMessage = _useState16[0],
    setOperationErrorMessage = _useState16[1];
  var handleDelete = function handleDelete(u) {
    setSelectedUser(u);
    confirm({
      title: 'Confirmez-vous ?',
      icon: /*#__PURE__*/_jsx(ExclamationCircleFill, {}),
      content: 'La supression de ' + u.firstname + '?',
      onOk: function onOk() {
        setIsProcessing(true);
        axios.post(Common.baseApiUrl + 'deleteuser/' + u.id.toString() + '/' + Common.currentUser.id).then(function (response) {
          setIsProcessing(false);
          if (response.data.status == 200) {
            setOperationSuccessMessage(response.data.message);
            setIsDataUpdated(true);
          } else {
            setOperationErrorMessage(response.data.message);
          }
        })["catch"](function (error) {
          setIsProcessing(false);
          setOperationErrorMessage(response.data.message);
        }).then(function () {
          setIsDataUpdated(false);
        });
      },
      onCancel: function onCancel() {
        console.log('Cancel');
      }
    });
  };
  var handleEdit = function handleEdit(u) {};
  var handleSwitch = function handleSwitch(u) {
    var action = u.status == 1 ? 'Bloquage' : 'Débloquage';
    Modal.confirm({
      title: 'Confirmation ',
      content: action + ' de ' + u.firstname + ' ' + u.lastname,
      onOk: function onOk() {
        axios.post(Common.baseApiUrl + 'witchuserstatus', {
          current: u.status,
          aid: Common.currentUser.id,
          uid: u.id
        }).then(function (response) {
          if (response.data.status == 200) {
            setIsDataUpdated(true);
            message.success({
              content: response.data.message,
              delay: 4
            });
          } else {
            message.error({
              content: response.data.message,
              delay: 4
            });
          }
        })["catch"](function (error) {
          message.error({
            content: 'Une erreur est survenue',
            delay: 4
          });
        });
      }
    });
  };
  useEffect(function () {
    setIsNewUserCreated(false);
    setIsDataUpdated(false);
    axios.get(Common.baseApiUrl + 'getplatformusers/' + Common.currentUser.id).then(function (response) {
      setIsDataLoading(false);
      setUsers(response.data.users);
    })["catch"](function (error) {
      setIsDataLoading(false);
    });
  }, [isNewUserCreated, isDataUpdated]);
  return /*#__PURE__*/_jsx(_Fragment, {
    children: /*#__PURE__*/_jsx(Container, {
      children: /*#__PURE__*/_jsxs(Row, {
        children: [/*#__PURE__*/_jsx(Col, {
          lg: 8,
          md: 9,
          children: /*#__PURE__*/_jsxs("div", {
            className: "white-bg cool-radius",
            children: [/*#__PURE__*/_jsxs(Space, {
              direction: "horizontal",
              children: [/*#__PURE__*/_jsx("h5", {
                children: "UTILISATEURS PLATEFORME"
              }), isProcessing && /*#__PURE__*/_jsx(Spin, {})]
            }), operationSuccessMessage.length != 0 && /*#__PURE__*/_jsx(Alert, {
              type: "success",
              message: operationSuccessMessage,
              showIcon: true
            }), operationErroMessage.length != 0 && /*#__PURE__*/_jsx(Alert, {
              type: "error",
              message: operationErroMessage,
              showIcon: true
            }), /*#__PURE__*/_jsx(Divider, {}), isDataLoading ? /*#__PURE__*/_jsx(Skeleton, {
              active: true
            }) : /*#__PURE__*/_jsx(_Fragment, {
              children: /*#__PURE__*/_jsxs(Table, {
                responsive: true,
                children: [/*#__PURE__*/_jsx("thead", {
                  children: /*#__PURE__*/_jsxs("tr", {
                    children: [/*#__PURE__*/_jsx("th", {
                      children: "Login"
                    }), /*#__PURE__*/_jsx("th", {
                      children: "Pr\xE9nom"
                    }), /*#__PURE__*/_jsx("th", {
                      children: "Nom"
                    }), /*#__PURE__*/_jsx("th", {
                      children: "Role"
                    }), /*#__PURE__*/_jsx("th", {}), /*#__PURE__*/_jsx("th", {}), /*#__PURE__*/_jsx("th", {})]
                  })
                }), /*#__PURE__*/_jsx("tbody", {
                  children: users.map(function (u) {
                    return /*#__PURE__*/_jsxs("tr", {
                      children: [/*#__PURE__*/_jsx("td", {
                        children: u.mobile.slice(3)
                      }), /*#__PURE__*/_jsx("td", {
                        children: u.firstname
                      }), /*#__PURE__*/_jsx("td", {
                        children: u.lastname
                      }), /*#__PURE__*/_jsxs("td", {
                        children: [u.role == 1 && 'Caisse', u.role == 2 && 'Labo', u.role == 3 && 'Medecine', u.role == 4 && 'Audio', u.role == 5 && 'Visio', u.role == 6 && 'Super OP', u.role == 8 && 'Finance', u.role == 9 && 'Administrateur', u.role == 10 && 'root']
                      }), /*#__PURE__*/_jsxs("td", {
                        children: [" ", /*#__PURE__*/_jsx(Button, {
                          type: "default",
                          onClick: function onClick() {
                            handleSwitch(u);
                          },
                          children: u.status == 1 ? /*#__PURE__*/_jsx(EyeFill, {
                            size: 22
                          }) : /*#__PURE__*/_jsx(EyeSlashFill, {
                            size: 22
                          })
                        })]
                      }), /*#__PURE__*/_jsx("td", {
                        children: /*#__PURE__*/_jsx(Button, {
                          type: "default",
                          onClick: function onClick() {
                            handleDelete(u);
                          },
                          children: /*#__PURE__*/_jsx(TrashFill, {
                            size: 22
                          })
                        })
                      }), /*#__PURE__*/_jsx("td", {
                        children: /*#__PURE__*/_jsx(Button, {
                          type: "default",
                          onClick: function onClick() {
                            handleEdit(u);
                          },
                          children: /*#__PURE__*/_jsx(PencilFill, {
                            size: 22
                          })
                        })
                      })]
                    }, u.id);
                  })
                })]
              })
            })]
          })
        }), /*#__PURE__*/_jsx(Col, {
          lg: 3,
          md: 3,
          children: /*#__PURE__*/_jsx("div", {
            className: "white-bg cool-radius",
            children: /*#__PURE__*/_jsx(NewUserForm, {
              handleUpdate: function handleUpdate() {
                setIsNewUserCreated(true);
              }
            })
          })
        })]
      })
    })
  });
};
export default PlatformUsersManagement;